/* eslint-disable no-shadow */
/* eslint-disable camelcase */
/* eslint-disable react/prop-types */
import { Checkbox } from '@components/form/checkbox';
import { Input } from '@components/form/input';
import { RadioForm } from '@components/form/radio/radio';
import { SelectDateCustom, SelectForm } from '@components/form/select';
import { SelectCreatableForm } from '@components/form/select/select-creatable-form';
import { Textarea } from '@components/form/textarea';
import {
  HrActionText,
  HrFlexContainer,
  HrParagraph,
  HrPrimary,
  HrRed,
  HrRedHover,
  HrTitleH5,
  Separate,
  Tablet
} from '@components/styles/hr-styles';
import { ErrorMessage } from '@hookform/error-message';
import { useMutation } from '@tanstack/react-query';
import { isEqual } from 'lodash';
import React, { useEffect, useRef, useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { getDeviceBreakpoint } from '../../../components/utilities/utilities';
import { vacancyRequirementType } from '../../../constant/vacancy-requirement';
import { buildSelectOptions } from '../../../utils/form';
import { getInstitutions } from '../../services/api';
import { DisplaySettingsContext } from '../../store/display-settings';

const Grid = styled.div`
  display: grid;
  gap: 24px;
  padding: 0 32px;
  box-sizing: border-box;
  width: 100%;
  grid-template-columns: repeat(3, 1fr);
  grid-template-areas:
    'input1 input2 input3'
    'input4 input5 input6'
    'input7 text-area text-area'
    'input8 text-area text-area'
    'input9 text-area text-area';
  & .item-1 {
    grid-area: input1;
  }
  & .item-2 {
    grid-area: input2;
  }
  & .item-3 {
    grid-area: input3;
  }
  & .item-4 {
    grid-area: input4;
  }
  & .item-5 {
    grid-area: input5;
  }
  & .item-6 {
    grid-area: input6;
  }
  & .item-7 {
    grid-area: input7;
  }
  & .item-8 {
    grid-area: input8;
  }
  & .item-9 {
    grid-area: input9;
  }
  & .item-area {
    grid-area: text-area;
  }
  @media (max-width: 768px) {
    padding: 0 16px;
    grid-template-columns: repeat(2, 1fr);
    grid-template-areas:
      'input1 input2'
      'input3 input4'
      'input5 input6'
      'input7 input9'
      'input8 input8'
      'text-area text-area';
  }
  @media (max-width: 464px) {
    grid-template-columns: repeat(1, 1fr);
    grid-template-areas:
      'input1'
      'input2'
      'input3'
      'input4'
      'input5'
      'input6'
      'input7'
      'input9'
      'input8'
      'text-area';
  }
`;

const Flex = styled(HrFlexContainer)`
  padding: 0 32px;

  @media (max-width: ${Tablet}) {
    padding: 0 16px;
  }
`;
const FlexSpacing = styled(HrFlexContainer)`
  @media (max-width: ${Tablet}) {
    padding: 0 16px;
  }
`;

const Addbutton = styled(HrActionText)`
  font-size: ${(props) => `${16 + (props.fontSizeSetting || 0)}px !important`};
  color: ${HrPrimary};
  margin-left: 32px !important;
  @media (max-width: 768px) {
    margin-left: 16px !important;
  }
`;

const obligatory = 1;

const educationDefault = {
  degree: '',
  locality: null,
  intitution: null,
  from_year: null,
  to_year: null,
  descript: '',
  study_level: null,
  study_status: null,
  area_education: null,
  actual_education: false
};

export const SectionEducation = ({
  vacancyRequirement,
  countries,
  studyAreas,
  studylevels,
  studyStatus,
  register,
  formState,
  control,
  setValue,
  unregister,
  getValues,
  postulant,
  action
}) => {
  const [t] = useTranslation();
  const [_educations, setEducations] = useState([]);
  const { educations } = postulant;

  useEffect(() => {
    const postEdu = postulant.educations ?? [];
    let currentEducation = [];
    currentEducation = action !== 'edit' ? getValues('educations') || [] : [];
    const filterDataEmpty = currentEducation.filter((educ) => {
      return !isEqual(educ, educationDefault);
    });
    if (filterDataEmpty.length === 0) {
      currentEducation = [];
    }
    const _education = postEdu.concat(currentEducation || []);

    const edu = _education.map((e, index) => {
      Object.keys(e).forEach((key) => {
        setValue(`educations.${index}.${key}`, e[key]);
      });
      return {
        position: index,
        delete: !(vacancyRequirement.educ === obligatory && index === 0)
      };
    });

    if (_education.length === 0 && vacancyRequirement.educ === obligatory) {
      setEducations([{ position: 1, delete: false, isDefault: true }]);
    } else {
      setEducations(edu);
    }

    return () => {
      return _education.length === 0;
    };
  }, [educations]);

  const handleAddEducation = () => {
    const cloneitems = JSON.parse(JSON.stringify(_educations));
    cloneitems.push({
      position: cloneitems.length || 0,
      delete: !(cloneitems.length === 0 && vacancyRequirement.educ === obligatory)
    });
    setEducations(cloneitems);
  };

  const handleDeleteEducation = (position) => {
    const cloneitems = JSON.parse(JSON.stringify(_educations));
    const dataFilter = cloneitems.filter((d, index) => {
      return index !== position;
    });
    let edus = JSON.parse(JSON.stringify(getValues('educations'))) || [];
    unregister(`educations`);
    edus = edus.filter((d, index) => {
      return position !== index;
    });
    edus.forEach((e, index) => {
      Object.keys(e).forEach((key) => {
        const _data = e[key];
        if (_data) {
          setValue(`educations.${index}.${key}`, _data);
        }
      });
    });
    setEducations(dataFilter);
  };

  const { darkMode, fontSizeSetting } = useContext(DisplaySettingsContext);

  return (
    <>
      {_educations &&
        _educations.map((e, index) => {
          return (
            <div key={`edu_${index * 1}`} style={{ width: '100%' }}>
              {_educations.length >= 2 && index > 0 && (
                <FlexSpacing padding='0 32px 16px 0'>
                  <Separate />
                </FlexSpacing>
              )}
              <Grid>
                <Input
                  title={t('postulant.education.input_title.degree')}
                  placeholder={t('postulant.education.input_placeholder.degree')}
                  name={`educations.${index}.degree`}
                  type='text'
                  register={register}
                  formState={formState}
                  validate={{
                    required: vacancyRequirement.educ === obligatory,
                    whiteSpace: false
                  }}
                  className='item-1'
                  errorPosition='bottom'
                  handlerOnBlur={(e) => {
                    setValue(`educations.${index}.degree`, e.target.value);
                  }}
                />
                <CountryInstitucion
                  vacancyRequirement={vacancyRequirement}
                  countries={countries}
                  index={index}
                  control={control}
                  formState={formState}
                  locality={getValues(`educations.${index}.locality`)}
                />
                <SelectForm
                  title={t('postulant.education.input_title.area_education')}
                  id={`educations.${index}.area_education`}
                  data={studyAreas}
                  control={control}
                  formState={formState}
                  isSearchable
                  validate={{ required: vacancyRequirement.educ === obligatory }}
                  disabled={studyAreas.length === 0}
                  className='item-4'
                  errorPosition='bottom'
                />
                <SelectForm
                  title={t('postulant.education.input_title.study_level')}
                  id={`educations.${index}.study_level`}
                  data={studylevels}
                  control={control}
                  formState={formState}
                  isSearchable
                  validate={{ required: vacancyRequirement.educ === obligatory }}
                  disabled={studylevels.length === 0}
                  className='item-5'
                  errorPosition='bottom'
                />
                <StateStudyDate
                  educations={educations}
                  vacancyRequirement={vacancyRequirement}
                  setValue={setValue}
                  index={index}
                  control={control}
                  formState={formState}
                  studyStatus={studyStatus}
                  unregister={unregister}
                />
                <div className='item-area'>
                  <Textarea
                    title={t('postulant.education.input_title.descript')}
                    id={`educations.${index}.descript`}
                    control={control}
                    placeholder={t('postulant.education.input_placeholder.descript')}
                    minHeight='155px'
                    errorPosition='bottom'
                  />
                </div>
              </Grid>
              {e.delete === true && (
                <HrFlexContainer width='100%' justifyContent='flex-end' padding='0 32px 0px 0' margin='16px 0 0 0'>
                  <HrActionText
                    alignItems='center'
                    onClick={() => {
                      handleDeleteEducation(index);
                    }}
                    color={HrRed}
                    colorHover={HrRedHover}
                    fontSize='14px'
                  >
                    <span style={{ fontSize: `${14 + fontSizeSetting || 0}px` }} className='hr-Trash' color={HrRed} />
                    <span style={{ fontSize: `${14 + fontSizeSetting || 0}px` }}>{t(`general.button.delete`)}</span>
                  </HrActionText>
                </HrFlexContainer>
              )}
            </div>
          );
        })}
      {vacancyRequirement.educ !== vacancyRequirementType.disabled && (
        <>
          <Addbutton fontSizeSetting={fontSizeSetting} onClick={handleAddEducation}>
            {t('postulant.education.add')}
          </Addbutton>
          <Separate borderBottom={darkMode ? '1px solid #767676' : ''} />
        </>
      )}

      {vacancyRequirement.school !== vacancyRequirementType.disabled && (
        <Flex flexDirection='column' alignItems='flex-start'>
          <HrTitleH5
            fontSizeSetting={fontSizeSetting}
            color={darkMode ? 'white' : ''}
            isRequired={vacancyRequirement.school === vacancyRequirementType.mandatory}
          >
            {t('postulant.education.high_school_data.title')}
          </HrTitleH5>

          <HrFlexContainer width='auto'>
            <RadioForm
              name='high_school_data'
              text={t('postulant.education.high_school_data.yes')}
              value='si'
              control={control}
              validate={{
                required: vacancyRequirement.school === vacancyRequirementType.mandatory
              }}
              key='high_school_data1'
              formState={formState}
              register={register}
              setValue={setValue}
              checked={getValues('high_school_data') === 'si' ? true : null}
            />
            <RadioForm
              name='high_school_data'
              text={t('postulant.education.high_school_data.no')}
              value='no'
              control={control}
              validate={{
                required: vacancyRequirement.school === vacancyRequirementType.mandatory
              }}
              key='high_school_data2'
              register={register}
              setValue={setValue}
              checked={getValues('high_school_data') === 'no' ? true : null}
            />
            <ErrorMessage
              errors={formState.errors}
              name='high_school_data'
              render={({ message }) => <HrParagraph color={HrRed}>{message}</HrParagraph>}
            />
          </HrFlexContainer>
        </Flex>
      )}
    </>
  );
};

export const CountryInstitucion = ({ vacancyRequirement, locality, index, countries, control, formState }) => {
  const [t] = useTranslation();
  const [institutions, setInstitutions] = useState([]);

  const _getInstitutions = useMutation(getInstitutions, {
    onSuccess: (data) =>
      setInstitutions(
        buildSelectOptions(data.data.response.institucion || [], 'nombre', 'id').sort((a, b) =>
          a.label.localeCompare(b.label)
        )
      )
  });

  const handleChangeInstitutions = (id) => _getInstitutions.mutate(id);

  useEffect(() => {
    if (locality) _getInstitutions.mutate(locality);
  }, [locality]);

  return (
    <>
      <SelectForm
        title={t(`postulant.education.input_title.locality`)}
        id={`educations.${index}.locality`}
        data={countries}
        control={control}
        formState={formState}
        isSearchable
        validate={{ required: vacancyRequirement.educ === obligatory }}
        disabled={countries.length === 0}
        onChangee={(data) => {
          handleChangeInstitutions(data.value);
        }}
        className='item-2'
        errorPosition='bottom'
      />
      <SelectCreatableForm
        formState={formState}
        validate={{
          required: vacancyRequirement.educ === obligatory
        }}
        control={control}
        isLoading={_getInstitutions.isLoading}
        name={`educations.${index}.intitution`}
        inputId={`educations.${index}.intitution`}
        data={institutions}
        title={t(`postulant.education.input_title.intitution`)}
        isDisabled={institutions?.length === 0 || _getInstitutions.isLoading}
        className='item-3'
        errorBottom
      />
    </>
  );
};

export const StateStudyDate = ({
  educations = [],
  vacancyRequirement,
  index,
  setValue,
  control,
  formState,
  studyStatus,
  unregister
}) => {
  const [toYearDisabled, setToYearDisabled] = useState(false);
  const [t] = useTranslation();
  const education = educations[index] || {};
  const { actual_education } = education;
  const [disabledCheckbox, setDisabledCheckbox] = useState(false);

  useEffect(() => {
    if (actual_education) {
      setToYearDisabled(true);
      unregister(`educations.${index}.to_month`);
      unregister(`educations.${index}.to_year`);
    }
  }, [actual_education]);

  const handleCheckActualEducation = (e, position, type) => {
    if (type === 'actual_education' && e.target.checked === true) {
      setValue(`educations.${position}.to_year`, '');
      unregister(`educations.${position}.to_month`);
      unregister(`educations.${position}.to_year`);
      setToYearDisabled(true);
    } else if (type === 'study_status' && [1].includes(e.value)) {
      setValue(`educations.${position}.to_year`, '');
      setValue(`educations.${position}.actual_education`, true);
      unregister(`educations.${position}.to_month`);
      unregister(`educations.${position}.to_year`);
      setToYearDisabled(true);
    } else {
      setValue(`educations.${position}.actual_education`, false);
      setToYearDisabled(false);
    }
  };

  const checkboxHTML = () => {
    const education = educations[index] || {};
    const { actual_education = false } = education;
    const ref = useRef(`educations.${index}.actual_education`);
    return (
      <Checkbox
        label={t('postulant.education.actual_education')}
        name={`educations.${index}.actual_education`}
        refCustom={ref}
        control={control}
        className='item-8'
        onChange={(e) => {
          handleCheckActualEducation(e, index, 'actual_education');
        }}
        defaultChecked={actual_education}
        disabled={disabledCheckbox}
      />
    );
  };

  const handleDisabledCheckbox = (e) => {
    if (e.value === 1) {
      setDisabledCheckbox(false);
      return;
    }

    setDisabledCheckbox(true);
  };

  return (
    <>
      <SelectForm
        title={t('postulant.education.input_title.study_status')}
        id={`educations.${index}.study_status`}
        data={studyStatus}
        control={control}
        formState={formState}
        isSearchable
        validate={{ required: vacancyRequirement.educ === obligatory }}
        disabled={studyStatus.length === 0}
        className='item-6'
        onChangee={(e) => {
          handleDisabledCheckbox(e);
          handleCheckActualEducation(e, index, 'study_status');
        }}
        errorPosition='bottom'
      />

      <SelectDateCustom
        title={t('postulant.education.input_title.from_year')}
        ids={{ year: `educations.${index}.from_year`, month: `educations.${index}.from_month` }}
        control={control}
        formState={formState}
        isSearchable
        validate={{ required: vacancyRequirement.educ === vacancyRequirementType.mandatory }}
        errorPosition='bottom'
      />
      {getDeviceBreakpoint().device === 'pc' && checkboxHTML(index)}
      <SelectDateCustom
        title={t('postulant.education.input_title.to_year')}
        ids={{ year: `educations.${index}.to_year`, month: `educations.${index}.to_month` }}
        control={control}
        formState={formState}
        isSearchable
        disabled={toYearDisabled}
        validate={{
          required: vacancyRequirement.educ === vacancyRequirementType.mandatory && !toYearDisabled
        }}
        errorPosition='bottom'
      />
      {getDeviceBreakpoint().device !== 'pc' && checkboxHTML(index)}
    </>
  );
};
